import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../ui-components/shared.module';
import { PermissionsService } from '../../guards/navigation.guard';

/**
 * « Pas de connexion » plein écran (P0.7) : jeton expiré et serveur injoignable
 * au lancement. Les jetons sont gardés, on propose de réessayer au lieu de
 * renvoyer vers la connexion. Même gabarit que « Une nouvelle version »
 * (`vw-app-update-screen`) : Willy, titre, texte, bouton principal pleine
 * largeur. Avant : pictogramme gris sur fond blanc pur et petit bouton contour.
 */
@Component({
  selector: 'vw-session-offline-screen',
  imports: [SharedModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (permissions.blockedUrl()) {
      <div role="alertdialog" aria-modal="true" aria-labelledby="session-offline-title" data-testid="session-offline"
        class="fixed inset-0 z-[1000] flex flex-col items-center justify-center bg-vw-bg px-6 pt-safe-top pb-safe-bottom text-center">
        <img src="assets/images/willy/willy_dontknow.png" alt=""
          class="h-[120px] w-[120px] rounded-pill bg-vw-surface-tint object-cover object-top" />
        <h1 id="session-offline-title" class="mt-6 text-title-l text-vw-ink">
          {{ 'components.session-offline.title' | translate }}
        </h1>
        <p class="mt-3 text-body text-vw-body">{{ 'components.session-offline.message' | translate }}</p>
        <vw-button look="primary" class="w-full" customClass="mt-8 w-full" [loading]="permissions.retrying()"
          [label]="'components.error-state.retry' | translate" (onClick)="permissions.retryBlockedNavigation()" />
      </div>
    }
  `,
})
export class SessionOfflineScreenComponent {
  readonly permissions = inject(PermissionsService);
}
